import * as Common from '@/tenantCatalog/common';

export class PaymentItem extends Common.ObjectBase{
  constructor(){
    super('PaymentItem');
    this.binders.tenant = new Common.ModelBinder(Common.Tenant);    
  }
  public get tenantId() :string{
    return this.tenant? this.tenant.id : '';
  } 
  public set tenantId(value:string) {}
  public tenant : Common.Tenant;
  public closingDate : Date;
  public paymentDate : Date = new Date().getCalendarDate();;
  public paidAmount : number;
  public paymentAgent: number;  
  public description : string;
  public batch : boolean = false;

}

export class PaymentItemQuery extends Common.LoadQuery {
  constructor(){
    super('PaymentItemQuery',PaymentItem);
    this.sort = 'tenantId';    
  }
  public tenantId :string = '';
  public tenantName: string = '';
  public closingDate : Date = null;    
  public paymentDateFrom : Date = null;
  public paymentDateTo: Date = null;
  public batch : boolean = null;    
  public paymentAgent:number;  
}